import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import OuterLayoutRoute from 'Pages/Layouts/OuterLayoutRoute';
import Enquiry from 'Pages/OuterPages/EnquiryDetails';
import Signup from 'Pages/OuterPages/Signup';
import SignupWithEkyc from 'Pages/OuterPages/SignupWithEkyc';
import IndexSignUp from 'Pages/OuterPages/IndexSignUp';

import { OTTIndexApp } from 'Pages/OuterPages/OTT/OTTIndexApp';
import { LeadGenerationIndexApp } from 'Pages/OuterPages/LeadGeneration/LeadGenerationIndexApp';
import { DTHIndexApp } from 'Pages/OuterPages/TransactionIndex/DTHIndexApp';
//import { IndexApp } from 'Pages/OuterPages/TransactionIndex/IndexApp';
import Login from 'Pages/OuterPages/Login';

import { OTTTransactionApp } from 'Pages/OuterPages/OTT/Paysprint/App/OTTIndex';
import { OTTTransactionBundleAPP } from 'Pages/OuterPages/OTT/Paysprint/App/OTTTransactionBundle';
import { OTTTransactionSubscriptionAPP } from 'Pages/OuterPages/OTT/Paysprint/App/OTTTransactionSubscription';
import { SDKTransaction } from 'Pages/OuterPages/SDK_UI/SDKTransaction';
import { Report } from 'Pages/OuterPages/SDK_UI/Last10Report';
import { SDKLinks } from 'Pages/OuterPages/SDK_UI/Index';
import { Complaint } from 'Pages/OuterPages/SDK_UI/Complaint';
import { SDKAccessDenied } from 'Pages/OuterPages/SDK_UI/SDKAccessDenied';

const ForgotPasswordGenerateOTP = lazy(() =>
    import('Pages/OuterPages/ForgotPasswordGenerateOTP')
);
const IndexApp = lazy(() =>
    import('Pages/OuterPages/TransactionIndex/IndexApp')
);

const PaysprintLeadGenerationApp = lazy(() =>
    import(
        'Pages/OuterPages/LeadGeneration/Paysprint/PaysprintLeadGenerationApp'
    )
);
const OuterLayoutNavigator = () => {
    const RoutePath = [
        '/Login',
        '/Signup',
        '/AboutUs',
        '/PublicServices',
        '/TermsAndConditions',
        '/PrivacyPolicy',
        '/RefundAndCanclePolicy',
        '/ContactUs',
        '/Home',
        '/ForgotPassword',
        '/OTTIndexApp',
        '/OTTTransactionApp',
        '/OTTTransactionSubscriptionAPP',
        '/OTTTransactionBundleAPP',
        '/LeadGenerationIndexApp',
        '/DTHIndexApp',
        '/IndexApp',
        '/PSLeadGenerationApp',
        '/SDK',
        '/SDKTransaction',
        '/SDKReport',
        '/SDKComplaint',
        '/SDKAccessDenied',
        '/SignupWithEkyc',
        '/IndexSignUp'
    ];
    return (
        <Route path={RoutePath}>
            <OuterLayoutRoute path="/Login" component={Login} />
            <OuterLayoutRoute path="/Enquiry" component={Enquiry} />
            <OuterLayoutRoute
                path="/ForgotPassword"
                component={ForgotPasswordGenerateOTP}
            />
            <OuterLayoutRoute path="/Signup" component={Signup} />
            <OuterLayoutRoute
                path="/SignupWithEkyc"
                component={SignupWithEkyc}
            />
            <OuterLayoutRoute path="/IndexSignUp" component={IndexSignUp} />
            <OuterLayoutRoute
                path="/OTTIndexApp"
                exact
                component={OTTIndexApp}
            />
            <OuterLayoutRoute
                path="/OTTTransactionApp"
                exact
                component={OTTTransactionApp}
            />
            <OuterLayoutRoute
                path="/OTTTransactionSubscriptionAPP"
                exact
                component={OTTTransactionSubscriptionAPP}
            />
            <OuterLayoutRoute
                path="/OTTTransactionBundleAPP"
                exact
                component={OTTTransactionBundleAPP}
            />
            <OuterLayoutRoute
                path="/LeadGenerationIndexApp"
                exact
                component={LeadGenerationIndexApp}
            />
            <OuterLayoutRoute
                path="/DTHIndexApp"
                exact
                component={DTHIndexApp}
            />
            <OuterLayoutRoute path="/IndexApp" exact component={IndexApp} />
            <OuterLayoutRoute
                path="/PSLeadGenerationApp"
                component={PaysprintLeadGenerationApp}
            />
            <OuterLayoutRoute
                path="/SDKTransaction"
                exact
                component={SDKTransaction}
            />
            <OuterLayoutRoute path="/SDKReport" component={Report} />
            <OuterLayoutRoute path="/SDK" component={SDKLinks} />
            <OuterLayoutRoute path="/SDKComplaint" component={Complaint} />
            <OuterLayoutRoute
                path="/SDKAccessDenied"
                component={SDKAccessDenied}
            />
        </Route>
    );
};

export default OuterLayoutNavigator;
